<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    VclList,
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
      loading: true,
      errored: false,
      total: 0,
      fields: [
        { key: "id", label: "" },
        { key: "name", label: "Nome", sortable: true, },
        { key: "person_number", label: "CPF/CNPJ", sortable: true, },
        { key: "email", label: "E-mail", sortable: true, },
        { key: "cellphone", label: "Celular", sortable: true, },
        { key: "city", label: "Cidade", sortable: true, },
      ],
      items: null,

      sortBy: "name",
      sortDesc: false,
      currentPage: "1",
      perPage: "10",
      filter: "",

      del: {
        modal: false,
        id: null,
      },
    };
  },
  methods: {
    getClientes() {
      this.loading = true;

      api.get("clientes").then((res) => {
        if (res.data.status == "success") {
          this.total = res.data.total;
          this.items = res.data.list;
        }
      })
        .catch((error) => {
          this.errored = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showDelete(id) {
      this.del.modal = true;
      this.del.id = id;
    },
    delCliente() {
      if (this.del.id) {
        this.del.modal = false;

        api.delete("clientes/" + this.del.id).then((res) => {
          if (res.data.status == "success") {
            this.getClientes();
            this.$toast.success('O cliente foi excluído com sucesso.');
          }
        })
      }
    },
  },
  mounted() {
    this.getClientes();
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Clientes</h3>
        <p>Gerencie seus clientes para realizar suas vendas.</p>
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <div class="totals">
        <h6 class="m-0">{{ this.total }}</h6>
        <h6 class="m-0 text-secondary">Total de clientes</h6>
      </div>
      <b-dropdown class="bg-white" variant="outline-light">
        <template #button-content>
          Itens por página
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <b-dropdown class="bg-white" variant="outline-light">
        <template #button-content>
          Ações
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-item to="clientes/cadastrar">Cadastrar</b-dropdown-item>
        <b-dropdown-item to="clientes/importar" class="d-none">Importar</b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="errored" class="text-center">
          Pedimos desculpas, não podemos recuperar informações neste momento. Por favor, tente novamente mais tarde.
        </div>
        <vcl-list v-else-if="loading" class="col-md-6"></vcl-list>
        <div v-else-if="items && items.length == 0" class="text-center">
          Nenhum cliente encontrado.
        </div>
        <div v-else class="table-responsive">
          <b-input v-model="filter" placeholder="Busca" class="mb-4"></b-input>
          <b-table :items="items" :fields="fields" class="table-nowrap table-style table-hover" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :current-page="currentPage" :per-page="perPage" :filter="filter" responsive>
            <template #cell(cellphone)="row">
              {{ row.item.cellphone }}
            </template>
            <template #cell(city)="row">
              {{ row.item.city }}/{{ row.item.state }}
            </template>
            <template #cell(id)="row">
              <b-dropdown variant="more">
                <template #button-content>
                  <i class="fas fa-ellipsis-h"></i>
                </template>
                <b-dropdown-item :to="'/clientes/' + row.item.id"><i class="bx bx-pencil"></i>
                  editar</b-dropdown-item>
                <b-dropdown-item @click="showDelete(row.item.id)"><i class="bx bx-trash"></i> excluir</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" pills align="center"></b-pagination>

    <b-modal v-model="del.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Excluir cliente</h4>
        <p>Confirma exclusão do cliente?</p>
        <div class="d-flex">
          <button class="btn btn-default mr-3" v-on:click="delCliente">Confirmar</button>
          <button class="btn btn-outline-link" v-on:click="del.modal = false">Fechar <sup>ESC</sup></button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>